import { createSlice, type PayloadAction } from "@reduxjs/toolkit"


const initialState : Record<string, any> = {
  featureFlags: {},
}

const featureFlagsSlice = createSlice({
  name: "featureFlags",
  initialState,
  reducers: {
    setFeatureFlags: (state, action: PayloadAction<Record<string, any>>) => {
      state.featureFlags = action.payload
    },
  },
})

export const {
    setFeatureFlags
} = featureFlagsSlice.actions

export default featureFlagsSlice.reducer

